<template>
  <div>
    <PendingUserForms v-if="pendingForms.length" :title="$t('table.pendingForms')" :items="pendingForms" />
    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item to="/my-forms/industrial_property/newIndustrialProperty">
            <v-list-item-icon><v-icon>mdi-plus</v-icon></v-list-item-icon>
            {{ $t("industrial_property.forms.newIndustrialProperty") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :items-per-page="15"
      class="elevation-1 table-cursor-hand mt-4"
      sort-by="application_date"
      sort-desc
      @click:row="openItem"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details />
        </v-toolbar>
      </template>
      <template v-slot:item.property_type="{ item }">
        {{ $t(`form.industrial_property.types.${item.property_type}`) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "@/components/forms/PendingUserForms";

export default {
  name: "ListIndustrialProperties",
  components: { PendingUserForms },
  data: () => ({ loading: true, search: "", items: [], pendingForms: [] }),
  computed: {
    headers() {
      return [
        { text: this.$t("form.industrial_property.title"), value: "title" },
        { text: this.$t("form.industrial_property.type"), value: "property_type" },
        { text: this.$t("form.industrial_property.application_number"), value: "application_number" },
        { text: this.$t("form.industrial_property.application_date"), value: "application_date" }
      ];
    }
  },
  created() {
    Promise.all([
      axios.get(`${this.$store.state.endpoint}/user/industrial_property`),
      axios.get(`${this.$store.state.endpoint}/user/moderatedOperations/pending/industrial_property`)
    ]).then(([items, forms]) => {
      this.items = items.data;
      this.pendingForms = forms.data;
    }).catch(error => console.error(error)).finally(() => { this.loading = false; });
  },
  methods: {
    openItem(item) {
      this.$router.push(`/industrial-property/${item.id}`);
    }
  }
};
</script>
